import SignUpStep1 from './SignUpStep1';
import SignUpStep2 from './SignUpStep2';

export const SignUpSteps = [SignUpStep1, SignUpStep2];
